/**
 * Type guard to check if an object conforms to the ErrorResponse structure
 *
 * @param body - The object to check
 * @returns True if the object conforms to the ErrorResponse structure, false otherwise
 */
export const isErrorBody = (body) => 'status_id' in body && 'status_message' in body;
/**
 * Extract function name from AWS Step Functions execution ARN
 * @param jobToken - AWS Step Functions execution ARN
 * @returns Function name (e.g., "DetectPolygonsVolumeStateMachine")
 */
export const extractFunctionNameFromArn = (jobToken) => {
    // ARN format: arn:aws:states:region:account:execution:StateMachineName-randomId:executionId
    const match = jobToken.match(/execution:([^-:]+)/);
    return match ? match[1] : null;
};
export const FUNCTION_NAME_TO_TRANSLATION_KEY_MAP = {
    DetectPolygonsVolumeStateMachine: 'errors.estimateVolume',
    DetectShapesStateMachine: 'errors.detectShapes',
    ReevaluateVolumeStateMachine: 'errors.estimateVolume',
    EvaluateGridStateMachine: 'errors.estimateGrid',
    DetectCracksStateMachine: 'errors.detectCracks',
    SavePolylinesWithWidthDetectionStateMachine: 'errors.detectCracks',
};
export const getTranslationKeyFromArn = (jobToken) => {
    const functionName = extractFunctionNameFromArn(jobToken);
    if (functionName && functionName in FUNCTION_NAME_TO_TRANSLATION_KEY_MAP) {
        return FUNCTION_NAME_TO_TRANSLATION_KEY_MAP[functionName];
    }
    return null;
};
/**
 * Get error translation key for a given job token and optional error object
 * @param jobToken - AWS Step Functions execution ARN
 * @param errorObject - Optional error object string from the response
 * @returns Error translation key to be used for localization
 */
export const getErrorTranslationKeyForJob = (jobToken, errorObject) => {
    if (errorObject) {
        const translationKey = getTranslationKeyFromArn(jobToken);
        try {
            const responseData = JSON.parse(errorObject);
            if (responseData?.body && responseData.body.includes('status_id')) {
                const parsedBody = JSON.parse(responseData.body);
                const parsed = JSON.parse(parsedBody.status_message);
                const statusId = parsed.status_id;
                if (translationKey) {
                    return `${translationKey}.${statusId}`;
                }
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    return `errors.common`;
};
